import {Checkbox} from "@octopusdeploy/design-system-components";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import * as React from "react";
import ReefMultiSelect from "shared/ReefMultiSelect";
import {ReefResource} from "client/resources/reefResource";
import InternalRedirect from "components/Navigation/InternalRedirect";
import {backgroundTasksRouteLinks} from "areas/backgroundTasks/backgroundTasksRouteLinks";
import { Callout } from "@octopusdeploy/design-system-components";
import {
    HostedInstanceBulkRotateSqlLoginsRequest
} from "../../../client/resources/HostedInstanceBulkRotateSqlLoginsRequest";
import {Text} from "../../../components/form";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
}

interface State extends DataBaseComponentState {
    hostedInstanceIdsDelimitedByLine: string;
    reefs: Map<string, ReefResource>;
    rotationRequest: HostedInstanceBulkRotateSqlLoginsRequest;
    redirectTo?: string;
}

class BulkRotateSqlLoginsDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            hostedInstanceIdsDelimitedByLine: "",
            reefs: new Map<string, ReefResource>(),
            rotationRequest: {
                HostedInstanceIds: [],
                ReefIds: [],
                RotateDuringWeekends: false
            },
        };
    }

    componentDidMount() {
        return this.doBusyTask(async () => {
            const reefs = repository.Reefs.map();

            this.setState({
                reefs: await reefs,
            });
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <InternalRedirect to={this.state.redirectTo}/>;
        }

        return <SaveDialogLayout title={`Bulk Rotate SQL Logins`}
                                 onSaveClick={() => this.bulkRotateSqlLogins()}
                                 errors={this.state.errors}
                                 busy={this.state.busy}>
            <Callout type="information" title="Further Action">
                Instances excluded from the <strong>Participate in bulk Instance SQL login rotation</strong> Portal
                Feature Flag will not have their logins rotated. These Instances require manual rotation.
            </Callout>

            <Checkbox value={this.state.rotationRequest.RotateDuringWeekends}
                      onChange={v => this.updateRotationRequest({RotateDuringWeekends: v})}
                      label="Rotate logins during weekends"/>
            <p>
                If unticked, SQL logins will be rotated only on weekdays. If ticked, logins will also rotate on
                weekends.
            </p>

            <ReefMultiSelect
                items={this.state.reefs ? Array.from(this.state.reefs.values()) : []}
                value={this.state.rotationRequest.ReefIds}
                onChange={ReefIds => this.updateRotationRequest({ReefIds})}
            />
            <p>
                SQL logins will rotate for all Instances only if they are on the selected Reefs. If no Reef
                is selected, every Instance's logins will rotate.
            </p>

            <Text label="Hosted Instance IDs (one per line)"
                  value={this.state.hostedInstanceIdsDelimitedByLine}
                  onChange={ids => this.updateHostedInstanceIds(ids)}
                  multiLine={true}
                  hintText={"IDs, e.g. HostedInstances-1"}
            />
        </SaveDialogLayout>;
    }

    private updateRotationRequest(update: Partial<HostedInstanceBulkRotateSqlLoginsRequest>) {
        return this.setState(prevState => ({rotationRequest: {...prevState.rotationRequest, ...update}}));
    }

    private updateHostedInstanceIds(idsDelimitedByLine: string) {
        return this.setState(prevState => ({
            hostedInstanceIdsDelimitedByLine: idsDelimitedByLine,
            rotationRequest: {
                ...prevState.rotationRequest,
                HostedInstanceIds: idsDelimitedByLine.split("\n").filter(id => id.trim() !== "")
            },
        }));
    }

    private async bulkRotateSqlLogins(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const backgroundTask = await repository.HostedInstances.bulkRotateSqlLogins(this.state.rotationRequest);
            this.setState({redirectTo: backgroundTasksRouteLinks.task(backgroundTask.Id).root})
        });
    }
}

export default BulkRotateSqlLoginsDialog;
